import React from "react"
import Markdown from "markdown-to-jsx"
import GalleryLink from "../../chat/SlickAIGalleryLink"
import { ParagraphBlock } from "./types"
import { linkifyUrls } from "@/components/chat/SlickAIMessage"

export const ParagraphRenderer = ({
  block,
  messageId,
  linkOverride,
}: {
  block: ParagraphBlock
  messageId: string
  linkOverride?: React.ComponentType<{
    href: string
    children: React.ReactNode
  }>
}) => {
  const LinkComponent = linkOverride || GalleryLink
  return (
    <div className="my-2">
      <Markdown
        options={{
          overrides: {
            a: {
              component: LinkComponent,
              props: linkOverride ? {} : { messageId },
            },
          },
        }}
      >
        {linkifyUrls(block.text)}
      </Markdown>
    </div>
  )
}
